/* file description */
import { ButtonLayout } from '@/asset/AssetTask/templates/Cascade/components';
import React, { useState } from 'react';
import { useButtonProps } from '../../effect/useButtonProps';
import { BtnInfoType } from '../../sp-business-btn';
import { Api } from '@cui/req';
import { readyDownload, getDownLoad } from '@/common/asset-apis/assetModel';
import { message } from 'antd';

interface ExportProps {
  btnInfo: BtnInfoType;
  utils: any;
  tableWithRef: any;
  className?: string;
}


export const Export: React.FC<ExportProps> = ({ btnInfo, utils, tableWithRef, className }) => {
  const [loading, setLoading] = useState(false);
  const option = useButtonProps(btnInfo);

  const clickBtn = async () => {
    setLoading(true);
    const params = (new Function("return " + btnInfo?.config))();
    // const search = JSON.parse(utils?.queryParams?.filterParams || '{}');
    // if (Object.keys(search)?.length > 0) {
    //   let changeFilter = '';
    //   Object.keys(search).forEach((key: string) => {
    //     if (search[key]) {
    //       changeFilter = changeFilter ? `${changeFilter} AND ${key} = '${search[key]}'` : `${key} = '${search[key]}'`;
    //     }
    //   });
    //   params.filterStr = changeFilter;
    // }
    if (tableWithRef?.current?.filterSql) {
      params.filterStr = tableWithRef?.current?.filterSql;
    }
    const readyRes = await readyDownload(Api, {
      ...params,
      taskId: btnInfo.taskId,
    });
    const res = await getDownLoad(Api, { taskId: readyRes });
    if (res.code === 200) {
      window.open(res.filePath);
      setLoading(false);
    } else {
      const interval = setInterval(() => {
        getDownLoad(Api, { taskId: readyRes }).then((result) => {
          if (result.code === 200) {
            clearInterval(interval);
            window.open(result.filePath);
            setLoading(false);
          }
          if (result.code !== 200 && result.code !== 37000) {
            clearInterval(interval);
            message.error(result.msg || '下载失败');
            setLoading(false);
          }
        });
      }, 1000);
    }
  };

  return (
    <>
      <ButtonLayout
        {...option}
        onClick={clickBtn}
        loading={loading}
        className={className}
      >{btnInfo.text}
      </ButtonLayout>
    </>
  );
};
